import { IPhoto } from '@bridebook/models/source/models/Suppliers/Photos.types';
import { Box, ImageX } from '@bridebook/ui';
import { getPhotoUrl } from '@bridebook/web/app-shared/lib/supplier/utils';
import componentStyles from './review-image.style';

export interface IProps {
  photo: Pick<IPhoto, 'path'>;
  lazyImage: boolean;
  onClick?: (imgUrl: string) => void;
}

const ReviewImage = ({ photo, onClick, lazyImage }: IProps) => {
  const imgUrl = getPhotoUrl(photo);

  const styles = componentStyles();

  return (
    <Box onClick={() => onClick?.(imgUrl)} style={styles.wrapper}>
      <ImageX
        src={imgUrl}
        w={501}
        h={213}
        loading={lazyImage ? 'lazy' : 'eager'}
        imageStyle={styles.img}
      />
    </Box>
  );
};

export default ReviewImage;
